import { CircularProgress } from "@mui/material";
import React from "react";
import styled from "styled-components";
import useVirtualCareSquads from "./useVirtualCareSquads";
import VCSCard from "./VCSCard";

const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  margin: -450px auto auto auto;
  max-width: 1200px;
  padding: 0 20px 72px;

  @media all and (min-width: 1200px) {
    margin-top: -331px;
    padding: 0 112px 120px;
  }
`;

const LoadingState = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -300px;
  width: 100%;
`;

const CareSquadCards = () => {
  const { isLoading, data } = useVirtualCareSquads();

  const isBcbsClient = React.useMemo(
    () => localStorage.getItem("is-bcbs-client") === "true",
    []
  );
  const filteredData = React.useMemo(() => {
    if (!data) return [];
    // eslint-disable-next-line no-console
    console.log(
      "\n\n\nCARE SQUAD CARDS DATA\n",
      JSON.stringify(data, null, 2),
      "\n\n\n"
    );
    if (isBcbsClient) {
      // return data;
      data.forEach((item) => {
        // eslint-disable-next-line no-console
        console.log("\n\nthe item here is", item);
      });
      return data.filter((item) => item.id === 1); // in production, the id is 3. In dev/and maybe staging - it is 13.
    }
    return data;
  }, [data, isBcbsClient]);

  if (isLoading) {
    return (
      <LoadingState>
        <CircularProgress />
      </LoadingState>
    );
  }

  return (
    <Container id="care-squad-cards-section">
      {filteredData?.map((item) => (
        <VCSCard item={item} key={item.id} />
      ))}
    </Container>
  );
};

export default CareSquadCards;
